<template>
<div>
  <!-- 首页 -->
  <div class="hello" v-if="isShow == 0">
    <div class="center">
      <div class="title">
          <p @click="changeButton(index)" :class="[isShow==index?'active':'']" v-for="(item,index) in title" :key="index">{{item}}</p>
      </div>
      <!-- <div class="img-down">
        <img class="img1" @click="downWin" src="../assets/1.png" alt="">		
        <img class="img2" @mouseleave="img5=false" @mouseover="img5=true" src="../assets/2.png" alt="">		
		<img class="img3" @click="downMac" src="../assets/3.png" alt="">
        <img class="img4" @mouseleave="img6=false" @mouseover="img6=true" src="../assets/4.png" alt="">
        <img v-if="img5" class="img5" src="../assets/qr1.png" alt="">
        <img v-if="img6" class="img6" src="../assets/qr2.png" alt="">
      </div> -->

      <div class="img-down-2">
        <!-- 上线需替换真实二维码 -->
        <!-- <img v-if="img1" class="img1" @click="downWin" @mouseleave="img1=true" @mouseover="img1=false" src="../assets/11.png" alt="">
        <img v-if="!img1" class="img1" @click="downWin" @mouseleave="img1=true" @mouseover="img1=false" src="../assets/windows.png" alt="">
		<img v-if="img2" class="img2" @click="downMac" @mouseleave="img2=true" @mouseover="img2=false" src="../assets/22.png" alt="">
        <img v-if="!img2" class="img2" @click="downMac" @mouseleave="img2=true" @mouseover="img2=false" src="../assets/mac.png" alt="">
        <img v-if="img3" class="img3" @mouseleave="img3=true" @mouseover="img3=false" src="../assets/33.png" alt="">
        <img v-if="!img3" class="img3" @mouseleave="img3=true" @mouseover="img3=false" src="../assets/ios.png" alt="">
        <img v-if="img4" class="img4" @mouseleave="img4=true" @mouseover="img4=false" src="../assets/44.png" alt="">
        <img v-if="!img4" class="img4" @mouseleave="img4=true" @mouseover="img4=false" src="../assets/an.png" alt=""> -->

        <!-- <img class="img1" @click="downWin" src="../assets/11.png" alt="">

        <img class="img11" @click="downWin" src="../assets/no.png" alt=""> -->

        <!-- <img class="img2" src="../assets/22.png" alt="">

        <img class="img22" src="../assets/no.png" alt=""> -->
<!-- 
        <img class="img3" src="../assets/33.png" alt="">

        <img class="img33" src="../assets/no.png" alt=""> -->

      </div>
    </div>

    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">深圳麟可科技有限公司 版权所有 粤ICP备2022020905号</a>
      <!-- <div class="info">服务热线: 0755-82571051 | 企业邮箱: everylinks@luehu.com</div> -->
    </div>

  </div>
  <!-- 下载页 -->
  <div class="download" v-if="isShow == 1" :style="cssVars">
    <div class="center">
      <div class="title">
        <p @click="changeButton(index)" :class="[isShow==index?'active':'']" v-for="(item,index) in title" :key="index">{{item}}</p>
      </div>
      <div class="img-down">
        <p @click="changedownload(index)" :class="[isdown==index?'active':'']" v-for="(item,index) in download" :key="index">{{item}}</p>
      </div>
    </div>

    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">深圳麟可科技有限公司 版权所有 粤ICP备2022020905号</a>
      <!-- <div class="info">服务热线: 0755-82571051 | 企业邮箱: everylinks@luehu.com</div> -->
    </div>
  </div>


</div>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      title:['首页','帮助'],
      download:['1分钟教程(客户端)','1分钟教程(移动端)'],
      isShow:0,
      isdown:0,
      cssVars:{'background':'url(' + require('../assets/pc.jpg') + ') no-repeat top'},
      img1:true,
      img2:true,
      img3:true,
      img4:false,
      img5:false,
      img6:false,
    }
  },
  methods:{
    downWin(){
      window.open('https://dl.everylinks.com/windows/gw/everylinks.exe')
    },
	downMac(){
      window.open('https://dl.everylinks.com/mac/gw/everylinks.dmg')
    },
    changeButton(index){
      this.isShow = index
      // if(index == 1){
      //   document.documentElement.scrollTop = 2500
      // }
    },
    changedownload(index){
      if(index == 0){
          this.cssVars=  {'background':'url(' + require('../assets/pc.jpg') + ') no-repeat top','min-height':'2776px'}
      }else{
          this.cssVars=  {'background':'url(' + require('../assets/mobile.jpg') + ') no-repeat top','min-height':'3126px'}
      }
      this.isdown = index
    }
  }
}
</script>

<style>
body{
  background-color: #161616;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.hello{
  position: absolute;
  width: 100%; 
  min-height: 3614px;
  background: url('~@/assets/home.jpg') no-repeat center;
  background-size: auto 3614px;
  /* background: red; */
  margin: 0px;
  padding: 0px;
  background-color: #161616;
  
  .beian{
    width: 100%;
    position: absolute;
    bottom: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #9E9E9E;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    a {
      color: #9E9E9E;
      text-decoration: none;
    }
  }

  .center{
    width: 1200px;
    min-height: 3614px;
    // background: blue;
    margin: 0 auto;
    position: relative;
  }
  .title{
    position: absolute;
    top:0px;
    right: 0px;
    width: 400px;
    height: 90px;
    // background: red;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    p{
      width: 120px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      // background: blue;
    }
    .active{
      color: #54CDA0;
      border-bottom: 2px solid #54CDA0;
    }
  }
  .img-down{
    position: absolute;
    top:330px;
    left: 0px;
    width: 360px;
    height: 360px;
    // background: red;
    .img1{
      position: absolute;
      bottom:60px;
      left: 0px;
      cursor: pointer;
    }
    .img2{
      position: absolute;
      bottom:60px;
      right: 0px;
      cursor: pointer;
    }
    .img3{
      position: absolute;
      bottom:0px;
      left: 0px;
      cursor: pointer;
    }
    .img4{
      position: absolute;
      bottom:0px;
      right: 0px;
      cursor: pointer;
    }
    .img5{
      position: absolute;
      bottom:110px;
      right: 0px;
    }
    .img6{
      position: absolute;
      bottom:50px;
      right: 0px;
    }
  }
  .img-down-2{
    position: absolute;
    bottom:360px;
    left: -100px;
    width: 1400px;
    height: 340px;
    // background: yellow;
    .img1{
      position: absolute;
      bottom:0px;
      left: 0px;
      cursor: pointer;
    }
    .img11{
      position: absolute;
      top:0px;
      left: 0px;
      cursor: pointer;
    }	
    .img2{
      position: absolute;
      bottom:0px;
      left: 373px;
      cursor: pointer;
    }
    .img22{
      position: absolute;
      top:0px;
      left: 373px;
      cursor: pointer;
    }
    .img3{
      position: absolute;
      bottom:0px;
      right: 0px;
      cursor: pointer;
    }
    .img33{
      position: absolute;
      top:0px;
      right: 0px;
      cursor: pointer;
    }
	.img4{
      position: absolute;
      bottom:0px;
      right: 373px;
      cursor: pointer;
    }
    .img44{
      position: absolute;
      top:0px;
      right: 373px;
      cursor: pointer;
    }
  }
}


.download{
  position: absolute;
  width: 100%; 
  min-height: 2776px;
  background: url('~@/assets/pc.jpg') no-repeat top;
  background-size: 100% 2776px;
  /* background: red; */
  background-color: #161616;
  margin: 0px;
  padding: 0px;
  .beian{
    width: 100%;
    position: absolute;
    bottom: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: #9E9E9E;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    a {
      color: #9E9E9E;
      text-decoration: none;
    }
  }
  .center{
    width: 1200px;
    min-height: 2776px;
    // background: blue;
    margin: 0 auto;
    position: relative;
  }
  .title{
    position: absolute;
    top:0px;
    right: 0px;
    width: 400px;
    height: 90px;
    // background: red;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    p{
      width: 120px;
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      // background: blue;
    }
    .active{
      color: #54CDA0;
      border-bottom: 2px solid #54CDA0;
    }
  }
  .img-down{
    position: absolute;
    top:356px;
    left: 0px;
    width: 300px;
    height: 160px;
    // background: red;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    p{
      width: 240px;
      height: 60px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
    }
    .active{
      background: #54CDA0;
      color: #1C1C1C;
    }
  }
}


</style>
